// extracted by mini-css-extract-plugin
export default {"tabModuleHead":"index_tabModuleHead_Dbzdv","item":"index_item_6W72q","title":"index_title_j8crR","active":"index_active_vfZP6","line":"index_line_pW35p","zggd":"index_zggd_hIAzG"};